/*
 * The Launch wizard route (U7). Renders `<LaunchWizard>` as full-screen page
 * content inside the app Shell (the Shell provides the chrome — top bar + nav
 * rail; the wizard fills the content area). Closing or cancelling returns to
 * the queue (`/`); a successful launch navigates to the new run's detail
 * (handled inside the wizard on the POST /runs success callback).
 *
 * The route is gated by `can('operate')` under `RequireBrand` (see
 * routes/index) — a viewer is bounced with a not-authorized fallback.
 */

import { useNavigate } from "react-router-dom";
import { LaunchWizard } from "../components/launch/LaunchWizard";

export function LaunchWizardPage() {
  const navigate = useNavigate();
  return <LaunchWizard onClose={() => navigate("/")} />;
}

export default LaunchWizardPage;
